import type { ReactNode } from 'react';

export interface CroppedImage {
  image: string;
  name: string;
  type: string;
}

export enum Trait {
  Culture = 'Culture',
  Facilities = 'Facilities',
  CostValue = 'Cost Value',
  Competition = 'Competition',
  Communication = 'Communication',
  Recruiting = 'Recruiting',
  Coaching = 'Coaching',
  PlayerDevelopment = 'Player Development',
}

export const TraitToColumnMap = {
  [Trait.Culture]: 'culture',
  [Trait.Facilities]: 'facilities',
  [Trait.CostValue]: 'costValue',
  [Trait.Competition]: 'competition',
  [Trait.Communication]: 'communication',
  [Trait.Recruiting]: 'recruiting',
  [Trait.Coaching]: 'coaching',
  [Trait.PlayerDevelopment]: 'playerDevelopment',
} as const;

export const TraitToLabelMap: Record<string, Trait> = {
  culture: Trait.Culture,
  facilities: Trait.Facilities,
  costValue: Trait.CostValue,
  competition: Trait.Competition,
  communication: Trait.Communication,
  recruiting: Trait.Recruiting,
  coaching: Trait.Coaching,
  playerDevelopment: Trait.PlayerDevelopment,
} as const;

export enum UserType {
  Personal = 'Personal',
  Organization = 'Organization',
}

export enum UserRole {
  Athlete = 'Athlete',
  Parent = 'Parent',
}

export enum StaffRole {
  Owner = 'Owner',
  HeadCoach = 'Head Coach',
  AssistantCoach = 'Assistant Coach',
  // vv This is the only place where the enum is used
  DirectorOfOperations = 'Director of Operations',
  OrganizationMember = 'Organization Member',
}

export const UserTypeToRoleMap: Record<UserType, (UserRole | StaffRole)[]> = {
  [UserType.Personal]: Object.values(UserRole),
  [UserType.Organization]: Object.values(StaffRole),
};

// ! do not use spaces in the values of this enum without updating everywhere
// ! if you have to add a two word value, it will
// ! require a refactor of where its used
export enum TeamInfoSection {
  Tryouts = 'Tryouts',
  Tournaments = 'Tournaments',
  Training = 'Training',
  Travel = 'Travel',
  Costs = 'Costs',
  Recruiting = 'Recruiting',
}

export enum SocialMedia {
  Website = 'website',
  Twitter = 'twitter',
  Facebook = 'facebook',
  Instagram = 'instagram',
  TikTok = 'tiktok',
  PerfectGame = 'perfect-game',
  YouTube = 'youtube',
}

export const PrettySocialMedia: Record<SocialMedia, string> = {
  [SocialMedia.Website]: 'Website',
  [SocialMedia.Twitter]: 'Twitter',
  [SocialMedia.Facebook]: 'Facebook',
  [SocialMedia.Instagram]: 'Instagram',
  [SocialMedia.TikTok]: 'TikTok',
  [SocialMedia.PerfectGame]: 'Perfect Game',
  [SocialMedia.YouTube]: 'YouTube',
};

export const SocialMediaDefaultValues: Record<SocialMedia, string> = {
  [SocialMedia.Website]: '',
  [SocialMedia.Twitter]: '',
  [SocialMedia.Facebook]: '',
  [SocialMedia.Instagram]: '',
  [SocialMedia.TikTok]: '',
  [SocialMedia.PerfectGame]: '',
  [SocialMedia.YouTube]: '',
};

export enum TeamClaimStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export const TeamClaimStatusIcons: Record<TeamClaimStatus, ReactNode> = {
  [TeamClaimStatus.PENDING]: '🕒',
  [TeamClaimStatus.APPROVED]: '✅',
  [TeamClaimStatus.REJECTED]: '❌',
};

export interface NearbyCityResponse {
  city: string;
  city_slug: string;
  state: string;
  count: string;
  distance: number;
}
